import AgreementList from '../components/agreement/List.vue';
import AgreementCreate from '../components/agreement/Create.vue';
import AgreementUpdate from '../components/agreement/Update.vue';
import AgreementShow from '../components/agreement/Show.vue';

export default [
  { name: 'AgreementList', path: '/agreements/', component: AgreementList },
  { name: 'AgreementCreate', path: '/agreements/create', component: AgreementCreate },
  { name: 'AgreementUpdate', path: "/agreements/edit/:id/:tab?", component: AgreementUpdate },
  { name: 'AgreementShow', path: "/agreements/show/:id", component: AgreementShow  }
];



// WEBPACK FOOTER //
// ./src/routes/agreement.js